"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUpdateWarehouseRequest = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
const isStruct_1 = require("../utils/isStruct");
const UpdateWarehouseRequestStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    pickUpAddress: (0, superstruct_1.optional)(types_1.PickUpAddressStruct),
    saleorWarehouseId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    isDraft: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    isTemporarilyClosed: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    isDistributionCenter: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    closedUntil: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    manuallyClosedReason: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    manuallyClosedLastChangeBy: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    isAutomaticThrottlingEnabled: (0, superstruct_1.optional)((0, superstruct_1.boolean)()),
    deliveryTime: (0, superstruct_1.optional)((0, superstruct_1.number)()),
});
function isUpdateWarehouseRequest(obj) {
    return (0, isStruct_1.isStruct)(obj, UpdateWarehouseRequestStruct, "UpdateWarehouseRequest");
}
exports.isUpdateWarehouseRequest = isUpdateWarehouseRequest;
//# sourceMappingURL=UpdateWarehouseRequest.js.map